import React from "react";
import { Stack } from "@mui/material";

const data = [{
  label: "Not Started",
  color: "#9CA3AF"
},
{
  label: "In Progress",
  color: "#FFA500"
},
{
  label: "Completed",
  color: "#008000"
}]

const ProgressLegend = () => {
  return (
    <Stack spacing={2.5} mb={3}>
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="text-[14px] font-medium text-gray-700 mb-3">
          Progress Status Legend
        </div>

        <div className="flex flex-wrap gap-4">
          {data?.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <div
                className="w-[50px] h-[20px] rounded"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-[14px] text-gray-700">
                {item.label}
              </span>
            </div>
          ))}
        </div>

      </div>
    </Stack>


  )
}

export default ProgressLegend;